import {StyledAlert} from './AlertStyles'
import PropTypes from 'prop-types'

const AlertErrorComponent = ({title, handleAlertClose}) => {
  return (
    <StyledAlert
      severity="error"
      onClose={() => {
        handleAlertClose()
      }}
    >
      {title}
    </StyledAlert>
  )
}

AlertErrorComponent.propTypes = {
  title: PropTypes.string,
  handleAlertClose: PropTypes.func
}

export default AlertErrorComponent
